import { Dialog, DialogContent } from '@mui/material';
import { FC, useMemo } from 'react';

import HeatMap from '@components/HeatMap';
import { ChartConfig } from '@DStypes/chart';
import { CloseButton } from '@components';

interface DataTableModalProps {
  chartData: any;
  chartConfig: ChartConfig;
  primaryColor: string;
  dropdownData: any;
  availableFields: any[];
  onClickRemoveWaterMark: () => void;
  onClose: () => void;
}

const DataTableModal: FC<DataTableModalProps> = ({
  chartData,
  chartConfig,
  primaryColor,
  dropdownData,
  availableFields,
  onClickRemoveWaterMark,
  onClose
}) => {
  const dropDownValues = {
    chart_operation: chartConfig.chart_operation,
    chart_type: chartConfig.chart_type,
    segment_field: chartConfig.segment_field?.id ?? '',
    x_axis: chartConfig.x_axis?.id ?? '',
    y_axis: chartConfig.y_axis?.id ?? ''
  };

  const segmentFields = useMemo(() => {
    if (dropdownData) {
      const options = [
        ...(dropdownData.available_fields || [])
          .filter((field: any) => field.is_segmentable === true)
          .map((field: any) => ({
            ...field,
            label: String(field.label)?.toLowerCase()
          }))
      ];

      if (
        dropDownValues.segment_field &&
        !options.find(
          (option: any) => option.value === dropDownValues.segment_field
        )
      ) {
        const newOption = dropdownData.available_fields.find(
          (field: any) => field.value === dropDownValues.segment_field
        );

        if (newOption)
          return [
            ...options,
            { ...newOption, label: String(newOption?.label)?.toLowerCase() }
          ];
      }

      return options;
    }

    return [];
  }, [dropdownData, dropDownValues.segment_field]);

  return (
    <Dialog
      open
      onClose={onClose}
      sx={{
        zIndex: 100,
        '& .MuiPaper-root': {
          width: '100vw',
          maxWidth: '70% !important',
          maxHeight: '70% !important',
          position: 'relative',
          overflow: 'visible'
        }
      }}
    >
      <CloseButton onClose={() => onClose()} />
      <DialogContent sx={{ py: 0, overflow: 'hidden' }}>
        <HeatMap
          xAxisKey={chartConfig?.x_axis?.fieldname ?? ''}
          dropDownValues={dropDownValues}
          segmentFields={segmentFields}
          tableData={chartData}
          xAxisLabelsExcluded={
            chartConfig.visual_settings?.filters?.xAxisLabelsExcluded
          }
          isFilterActive={
            chartConfig.visual_settings?.filters?.type === 'top' ||
            chartConfig.visual_settings?.filters?.type === 'bottom'
          }
          isDate={
            chartConfig?.x_axis?.treat_as_type === 'DATE' ||
            chartConfig?.x_axis?.treat_as_type === 'DATETIME'
          }
          isDateTime={chartConfig?.x_axis?.treat_as_type === 'DATETIME'}
          availableFields={availableFields}
          primaryColor={primaryColor}
          watermarkProps={{
            isKPI: chartConfig.chart_type === 'KPI',
            onClickRemoveWaterMark: onClickRemoveWaterMark
          }}
          showAsPercentage={
            chartConfig.visual_settings?.showAsPercentage as boolean
          }
        />
      </DialogContent>
    </Dialog>
  );
};

export default DataTableModal;
